import React, { useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { AuthProvider } from "./context/auth";
import AuthRoute from "./util/AuthRoute";
import "bootstrap/dist/css/bootstrap.css";
import "./style-semantic.css";
import "./estilos.css";
import Inicio from "./pages/Inicio";
import Login from "./pages/Login";
import SessionTimeout from "./components/sessionTimeout";
import HaciendaMunicipal from "./pages/hacienda/HaciendaMunicipal";

import Comercios from "./pages/hacienda/Comercios";
import Inmuebles from "./pages/catastro/catastro";
import ClaseActividades from "./pages/hacienda/ClaseActividades";
import EstadoCuenta from "./pages/hacienda/EstadoCuenta";
import UsuarioWeb from "./pages/hacienda/UsuarioWeb";
import ComerciosDeclarar from "./pages/hacienda/ComerciosDeclarar";
import ConsultarVerificacionPagosWeb from "./pages/hacienda/ConsultarVerificacionPagosWeb";
import VerificacionPagosWeb from "./pages/hacienda/VerificacionPagosWeb";
import UsuariosHacienda from "./pages/hacienda/UsuariosHacienda";
import FechasVencimiento from "./pages/hacienda/FechasVencimiento";
import SolicitudRenovacion from "./pages/hacienda/SolicitudRenovacion";
import SolicitudLicencia from "./pages/hacienda/SolicitudLicencia";
import ComerciosAgenteRetencion from "./pages/hacienda/ComerciosAgenteRetencion";
import InmueblesUrbanos from "./pages/hacienda/inmueblesUrbanos/inmueblesUrbanos";
import RegistroInmueble from "./pages/hacienda/inmueblesUrbanos/InmuebleContribuyente";
import EstadoCuentaInmueble from "./pages/hacienda/inmueblesUrbanos/estadoCuenta";
import ValorFiscalInmueble from "./pages/hacienda/inmueblesUrbanos/valorFiscalInmueble";
import UsuariosFacturacion from "./pages/hacienda/facturacion/UsuariosFacturacion";
import UsuariosInmbueblesUrbanos from "./pages/hacienda/inmueblesUrbanos/usuariosInmuebles";
import VincularInmueble from "./pages/hacienda/inmueblesUrbanos/vincularUsoInmueble.js";

import EstadoCuentaRenta from "./pages/hacienda/rentaInmobiliaria/rentaEstado";
import RentaInmobiliaria from "./pages/hacienda/rentaInmobiliaria/rentaInmobiliaria";
import ContribuyentesEjidos from "./pages/hacienda/rentaInmobiliaria/registroContribuyenteRentaEjidos";
import JuegosApuestas from "./pages/juegoApuestas/juegosLicitos";
import ContribuyentesJuegos from "./pages/juegoApuestas/contribuyentesJuegos";
import EstadoJuegos from "./pages/juegoApuestas/estadosApuestas";
import ImpuestoLicores from "./pages/hacienda/impuestoLicores/impuestosLicores";
import ContribuyentesLicores from "./pages/hacienda/impuestoLicores/contribuyentesLicores";
import UnidadMedidas from "./pages/comprasyalmacen/UnidadMedidas";
import TipoProducto from "./pages/comprasyalmacen/TipoProducto";
import Productos from "./pages/comprasyalmacen/Productos";
import Proveedores from "./pages/comprasyalmacen/Proveedores";

import AseoUrbano from "./pages/hacienda/rentaInmobiliaria/aseoUrbano";
import TipoDeRentas from "./pages/hacienda/rentaInmobiliaria/tiposRentas";
import ClasificadorAseo from "./pages/hacienda/rentaInmobiliaria/clasificadorAseo";
import OrdenCompra from "./pages/comprasyalmacen/OrdenCompra";
import ClasificadorTasas from "./pages/hacienda/impuestoLicores/clasificadorTasas";
import ClasificadorExpendios from "./pages/hacienda/impuestoLicores/clasificadorExpendios";
import EstadoCuentaLIcores from "./pages/hacienda/impuestoLicores/estadocuentaLic";
import MenuPrincipalCaja from "./components/hacienda/caja/menuPrincipalCaja";
import CajaIngresos from "./components/hacienda/caja/cajaingresos";

import Catastro from "./pages/catastro/catastro";
import MenuPrincipaAdmin from "./components/administracion/menuPrincipalAdmin";
import MenuPrincipalCompra from "./components/comprasyalmacen/menuPrincipalCompra";
import MenuPrincipaContFis from "./components/contabilidadFiscal/menuProcipalContFiscal";
import MenuPrincipalFacturacion from "./components/hacienda/facturacion/nuevoMenuFacturacion";
import MenuPresupuesto from "./components/presupuesto/MenuImpuestoPresupuesto.js";
import modulo404 from "./pages/404.js";
import MenuPrincipaActiComer from "./components/hacienda/actividadEconomica/menuPrincipalComercio.js";
import MenuImpuestoVe from "./components/hacienda/impuestovehiculos/MenuImpuestoVe.js";
import MenuImpuestoPP from "./components/hacienda/propagandaypublicidad/MenuImpuestoPP.js";
import MenuPrincipalGestionComercial from "./components/hacienda/gestionComercial/menuPrincipalGesrionCom.js";

import Ingenieria from "./pages/ingieneriaMunicipal/Ingieneria.jsx";
import Nomina from "./components/nomina/Nomina.jsx";
import GestionControl from "./components/gestionControl/GestionControl.jsx";
import BienesMunicipales from "./components/bienesMunicipales/BienesMunicipales.jsx";
import MenuPrincipalEjido from "./components/hacienda/rentaInmobiliaria/menuPrincipalEjidos.js";
import MenuPrincipaCatastro from "./components/catastro/menuPrincipalCatastro.js";
import Print from "./print.js";
import { WebSocketProvider } from "./context/WebSocketContext.js";
import Panel from "./components/hacienda/facturacion/panel";

function App() {
  const op = require("../src/modulos/datos.js");

  useEffect(() => {
    const changeFavicon = (src) => {
      let link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = src;
      document.getElementsByTagName("head")[0].appendChild(link);
    };

    changeFavicon(op.icon);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <SessionTimeout />
        <Route exact path="/" component={Login} />
        <Route exact path="/panel" component={Panel} />

        <WebSocketProvider url={op.ws}>
          <AuthRoute exact path="/inicio" component={Inicio} />
          {/* <AuthRoute exact path="/cambiarEfiscal" component={CambiarEfiscal} /> */}
          {/* <AuthRoute exact path="/efiscal" component={Efiscales} /> */}

          <AuthRoute
            exact
            path="/bienesMunicipales"
            component={BienesMunicipales}
          />

          <AuthRoute exact path="/nomina" component={Nomina} />
          {/*<AuthRoute exact path="/seleccionarNomina" component={SeleccionarNomina} />*/}
          <AuthRoute exact path="/gestionControl" component={GestionControl} />
          <AuthRoute exact path="/ingenieria" component={Ingenieria} />
          <AuthRoute exact path="/catastro" component={MenuPrincipaCatastro} />
          <AuthRoute
            exact
            path="/haciendaMunicipal"
            component={HaciendaMunicipal}
          />
          <AuthRoute
            exact
            path="/actividadEconomica"
            component={MenuPrincipaActiComer}
          />
          <AuthRoute
            exact
            path="/gestioncomercial"
            component={MenuPrincipalGestionComercial}
          />
          <AuthRoute exact path="/comercio" component={Comercios} />
          <AuthRoute
            exact
            path="/comercioDeclara"
            component={ComerciosDeclarar}
          />
          <AuthRoute
            exact
            path="/claseActividad"
            component={ClaseActividades}
          />
          <AuthRoute exact path="/estadoCuenta" component={EstadoCuenta} />
          <AuthRoute exact path="/usuarioweb" component={UsuarioWeb} />
          <AuthRoute exact path="/inmueble" component={Inmuebles} />
          <AuthRoute
            exact
            path="/consultarPagosweb"
            component={ConsultarVerificacionPagosWeb}
          />
          <AuthRoute
            exact
            path="/verificarPagosweb"
            component={VerificacionPagosWeb}
          />
          <AuthRoute
            exact
            path="/solicitudRenovacion"
            component={SolicitudRenovacion}
          />
          <AuthRoute
            exact
            path="/solicitudLicencia"
            component={SolicitudLicencia}
          />
          <AuthRoute
            exact
            path="/usuariosHacienda"
            component={UsuariosHacienda}
          />
          <AuthRoute
            exact
            path="/contabilidadPresupuestaria"
            component={MenuPresupuesto}
          />
          <AuthRoute
            exact
            path="/fechasVencimiento"
            component={FechasVencimiento}
          />
          <AuthRoute
            exact
            path="/agenteRetencion"
            component={ComerciosAgenteRetencion}
          />
          <AuthRoute
            exact
            path="/impuestoVehiculos"
            component={MenuImpuestoVe}
          />
          <AuthRoute
            exact
            path="/inmueblesUrbanos"
            component={InmueblesUrbanos}
          />
          <AuthRoute
            exact
            path="/registroContribuyenteInmueble"
            component={RegistroInmueble}
          />
          <AuthRoute
            exact
            path="/estadosCuentasInmuebles"
            component={EstadoCuentaInmueble}
          />
          <AuthRoute
            exact
            path="/comprasyAlmacen"
            component={MenuPrincipalCompra}
          />
          <AuthRoute exact path="/unidadMedidas" component={UnidadMedidas} />
          <AuthRoute exact path="/tipoProducto" component={TipoProducto} />
          <AuthRoute exact path="/productos" component={Productos} />
          <AuthRoute exact path="/proveedores" component={Proveedores} />
          <AuthRoute exact path="/impuestoPP" component={MenuImpuestoPP} />
          <AuthRoute
            exact
            path="/moduloFacturacion"
            component={MenuPrincipalFacturacion}
          />
          <AuthRoute
            exact
            path="/usuariosFacturacion"
            component={UsuariosFacturacion}
          />
          <AuthRoute
            exact
            path="/valoracionFiscalInmueble"
            component={ValorFiscalInmueble}
          />
          <AuthRoute
            exact
            path="/usuariosInmueble"
            component={UsuariosInmbueblesUrbanos}
          />
          <AuthRoute
            exact
            path="/vincularInmueble"
            component={VincularInmueble}
          />
          <AuthRoute
            exact
            path="/rentasInmobiliria"
            component={MenuPrincipalEjido}
          />
          <AuthRoute
            exact
            path="/registroEjidos"
            component={ContribuyentesEjidos}
          />
          <AuthRoute exact path="/estadoRenta" component={EstadoCuentaRenta} />
          <AuthRoute exact path="/JuegosApuestas" component={JuegosApuestas} />
          <AuthRoute
            exact
            path="/registrosApuestasLicitas"
            component={ContribuyentesJuegos}
          />
          <AuthRoute exact path="/estadoJuegos" component={EstadoJuegos} />
          <AuthRoute
            exact
            path="/impuestoLicores"
            component={ImpuestoLicores}
          />
          <AuthRoute
            exact
            path="/contribuyentesLicores"
            component={ContribuyentesLicores}
          />
          <AuthRoute exact path="/caja" component={MenuPrincipalCaja} />
          <AuthRoute exact path="/cajaIngreso" component={CajaIngresos} />
          <AuthRoute exact path="/registroAseoUrbano" component={AseoUrbano} />
          <AuthRoute exact path="/tipoRentas" component={TipoDeRentas} />
          <AuthRoute
            exact
            path="/clasificadorAseo"
            component={ClasificadorAseo}
          />
          <AuthRoute exact path="/ordenCompra" component={OrdenCompra} />
          <AuthRoute
            exact
            path="/clasificadorTasas"
            component={ClasificadorTasas}
          />
          <AuthRoute
            exact
            path="/clasificadorExpendios"
            component={ClasificadorExpendios}
          />
          <AuthRoute
            exact
            path="/estadoLicores"
            component={EstadoCuentaLIcores}
          />
          <AuthRoute
            exact
            path="/administracion"
            component={MenuPrincipaAdmin}
          />
          <AuthRoute
            exact
            path="/contafiscal"
            component={MenuPrincipaContFis}
          />
          <AuthRoute exact path="/404" component={modulo404} />
          <AuthRoute exact path="/print" component={Print} />
        </WebSocketProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
